<template>
  <div id="angebot-suche-modal" class="modal fade" style="z-index: 12000">
    <div class="modal-dialog modal-xl">
      <div class="modal-content" style="border: 1px solid black">
        <div class="modal-header">
          <modal-close-button @confirmed="abbrechen" />
          <h4 class="modal-title">
            {{
              uebertragen
                ? $t("global.transfertoanotheroffer")
                : $t("global.searchoffer")
            }}
          </h4>
        </div>
        <div class="modal-body">
          <div class="row mb-3">
            <div class="col-xl-1 px-3">
              <div class="form-group">
                <input
                  v-model.trim="filters.nummer"
                  class="form-control"
                  type="number"
                  placeholder=" "
                  min="0"
                  @keyup.enter="resetLoading()"
                />
                <label>{{ $t("global.number") }}</label>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>{{ $t("global.fromstart") }}</label>
                <input
                  v-model="filters.vonStart"
                  type="date"
                  class="form-control"
                  @change="resetLoading()"
                  :max="maxVonStart"
                />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>{{ $t("global.fromend") }}</label>
                <input
                  v-model="filters.vonEnde"
                  type="date"
                  class="form-control"
                  @change="resetLoading()"
                  :min="filters.vonStart"
                  :max="filters.bisEnde"
                />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>{{ $t("global.untilstart") }}</label>
                <input
                  v-model="filters.bisStart"
                  type="date"
                  class="form-control"
                  @change="resetLoading()"
                  :max="filters.bisEnde"
                  :min="filters.vonStart"
                />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>{{ $t("global.untilend") }}</label>
                <input
                  v-model="filters.bisEnde"
                  type="date"
                  class="form-control"
                  @change="resetLoading()"
                  :min="minBisEnde"
                />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <v-select
                  v-model="filters.angebotstatus"
                  label="bezeichnung"
                  :options="angebotstati"
                  :placeholder="$t('global.offerstatus')"
                  @input="resetLoading()"
                  multiple
                  :reduce="(s) => s.id"
                >
                  <span slot="no-options">{{ $t("global.taptosearch") }}</span>
                </v-select>
                <label>{{ $t("global.offerstatus") }}</label>
              </div>
            </div>
            <div class="col">
              <single-select-firma
                id="angebot-hof"
                :firma="filters.hof"
                :editable="true"
                :allowOpen="false"
                :label="$t('global.farm')"
                @confirmed="setHof"
                @removed="resetLoading()"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12 block modal-liste br-t-l-0">
              <div style="height: 300px !important">
                <b-table
                  responsive
                  sticky-header
                  selectable
                  select-mode="single"
                  @row-dblclicked="rowDblClick"
                  @row-selected="onRowSelected"
                  tbody-tr-class="item"
                  :items="angebote"
                  :fields="fields"
                  :busy="isBusy"
                  :show-empty="loaded"
                >
                  <template v-slot:cell(einsatzbereiche)="row">
                    {{
                      row.item.einsatzbereiche
                        .map((e) => e.bezeichnung)
                        .join(", ")
                    }}
                  </template>

                  <template v-slot:cell(ist_zeitbetrieb)="row">
                    {{ row.item.ist_zeitbetrieb ? "✓" : "" }}
                  </template>

                  <template #table-busy>
                    <div class="text-center text-primary my-2">
                      <b-spinner class="align-middle"></b-spinner>
                    </div>
                  </template>

                  <template #empty>
                    <div class="text-center text-primary my-2">
                      {{ $t("global.nodatafound") }}
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" @click="abbrechen">
            {{ $t("global.cancel") }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="uebernehmen"
            :disabled="selected.length == 0"
          >
            {{ uebertragen ? $t("global.transfer") : $t("global.apply") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import AppApi from "@/api/AppApi";
import ModalCloseButton from "@/components/global/ModalCloseButtonNew";
import { BSpinner } from "bootstrap-vue";
import { LADE_AUSWAHLWERTE_CRM } from "@/store/crm/actions.type";
import SingleSelectFirma from "@/components/global/SingleSelectFirma.vue";

export default {
  name: "angebotSucheModal",
  components: { ModalCloseButton, BSpinner, SingleSelectFirma },
  props: {
    uebertragen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isBusy: false,
      loaded: false,
      anzahlProPage: 99,
      angebote: [],
      selected: [],
      filters: [],
    };
  },
  computed: {
    fields() {
      return [
        {
          key: "nummer",
          sortable: true,
          label: this.$t("global.number"),
        },
        {
          key: "vermittlungsstelle.bezeichnung",
          sortable: true,
          searchable: false,
          label: this.$t("global.switchboard"),
        },
        {
          key: "von",
          sortable: true,
          searchable: false,
          label: this.$t("global.From"),
        },
        {
          key: "bis",
          sortable: true,
          searchable: false,
          label: this.$t("global.till"),
        },
        {
          key: "ist_zeitbetrieb",
          sortable: true,
          searchable: false,
          label: this.$t("global.actualtimeoperation"),
        },
        {
          key: "angebotstatus.bezeichnung",
          sortable: true,
          searchable: false,
          label: this.$t("global.offerstatus"),
        },
        {
          key: "firma.name",
          sortable: true,
          searchable: false,
          label: this.$t("global.farm"),
        },
        {
          key: "einsatzbereiche",
          sortable: true,
          searchable: false,
          label: this.$t("global.areasofapplication"),
        },
      ];
    },
    queryParams: function () {
      var params = {};

      params.filterNummer = this.filters.nummer;
      params.filterFirma = this.filters.hof?.id;
      params.filterAngebotstatus = this.filters.angebotstatus?.join(",");
      params.filterVonStart = this.isoToGerman(this.filters.vonStart);
      params.filterVonEnde = this.isoToGerman(this.filters.vonEnde);
      params.filterBisStart = this.isoToGerman(this.filters.bisStart);
      params.filterBisEnde = this.isoToGerman(this.filters.bisEnde);
      params.count = this.filters.count ? this.filters.count : 50;

      return params;
    },
    angebotstati() {
      if (this.$store) return this.$store.state.crm.angebotstati;
      return [];
    },
    maxVonStart() {
      const { vonEnde, bisEnde } = this.filters;

      if (!vonEnde) return bisEnde || null;
      if (!bisEnde) return vonEnde;

      return new Date(vonEnde) < new Date(bisEnde) ? vonEnde : bisEnde;
    },
    minBisEnde() {
      const { vonStart, bisStart } = this.filters;

      if (!vonStart) return bisStart || null;
      if (!bisStart) return vonStart;

      return new Date(vonStart) > new Date(bisStart) ? vonStart : bisStart;
    },
  },
  watch: {},
  created() {
    this.resetLoading();
  },
  mounted() {
    this.$bus.$on("open-angebot-suche-modal", (id) => {
      if (!this.shown) this.openModal();
    });

    if (this.angebotstati?.length == 0)
      this.$store.dispatch(`crm/${LADE_AUSWAHLWERTE_CRM}`);
  },
  methods: {
    isoToGerman(dateString) {
      if (!dateString) {
        return null;
      }
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${day}.${month}.${year}`;
    },

    openModal() {
      this.shown = true;

      let that = this;

      $("#angebot-suche-modal").on("shown.bs.modal", function () {
        if (that.$refs && that.$refs.editName) that.$refs.editName.focus();
      });

      $("#angebot-suche-modal").modal({
        backdrop: "static",
        keyboard: false,
      });
    },

    closeModal() {
      this.$bus.$emit("sucheModalClose");
      this.shown = false;
      $("#angebot-suche-modal").modal("hide");
    },

    onRowSelected(items) {
      this.selected = items;
    },

    rowDblClick(item) {
      this.selected = [item];
      this.uebernehmen();
    },

    resetLoading() {
      this.isBusy = true;

      AppApi.get("angebotliste/", {
        params: this.queryParams,
      })
        .then((response) => {
          //response.data.shift();
          this.angebote = response.data;
        })
        .finally(() => {
          this.isBusy = false;
          this.loaded = true;
        });
    },

    entfernen() {
      this.closeModal();
      this.$emit("confirmed", { name: this.$t("global.notlinked") });
    },

    uebernehmen() {
      if (this.selected == null || this.selected.length == 0) return;
      this.closeModal();
      this.$emit("confirmed", this.selected);
    },

    abbrechen() {
      this.closeModal();
    },

    setHof(hof) {
      this.$set(this.filters, "hof", hof);
      this.resetLoading();
    },
  },
};
</script>
